export const SUPPORT_MODES = ["WIFEED", "EMAIL", "NONE"];

export const UNAVAILABLE_SUPPORT_MODES = { vivo: ["WIFEED"] };

export function sanitizeSupportMode(value) {
    if (!value) return null;

    return SUPPORT_MODES.includes(value) ? value : "WIFEED";
}

export function resolveProviderSupport(provider) {
    if (provider === "vivo") {
        return { mode: "EMAIL", email: "servicosdigitais@vivo.com.br" };
    }

    return { mode: "WIFEED", email: "" };
}

export function resolveAccountSupport({ provider, mode, email }) {
    const isEmailWithoutAddress = mode === "EMAIL" && !email;
    const isUnavailable = (UNAVAILABLE_SUPPORT_MODES[provider] || []).includes(mode);

    if (!mode || isEmailWithoutAddress || isUnavailable) {
        return resolveProviderSupport(provider);
    }

    return { mode, email };
}
